import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      <div className="landing-container">
        {/* Top Left - Small Logo */}
        <div className="landing-header-logo">
          <img src="/logo-small.png" alt="SSM" />
        </div>

        {/* Company Logo (Full - Center) */}
        <div className="landing-logo-section">
          <div className="landing-logo">
            <img src="/logo-full.png" alt="Skilled Safety Management" />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="landing-buttons">
          <button
            className="landing-upload-btn"
            onClick={() => navigate('/upload-form')}
          >
            Upload/Submit
          </button>

          <button
            className="landing-documents-btn"
            onClick={() => navigate('/documents')}
          >
            Documents
          </button>
        </div>

        {/* Phone Number */}
        <div className="landing-phone">
          <a href="tel:+12124988863">+1 (212)-498-8863</a>
        </div>

        {/* Admin Link */}
        <div className="landing-admin-link">
          <a href="#admin" onClick={(e) => { e.preventDefault(); navigate('/admin'); }}>
            Admin Panel
          </a>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
